/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedDescriptionAdditionalOptionsContent_user$ref = any;
export type PdpSharedDescriptionAdditionalOptions_user$ref = any;
export type PdpSharedDescriptionAdditionalOptions_user = {
    readonly " $fragmentRefs": PdpSharedDescriptionAdditionalOptionsContent_user$ref;
    readonly " $refType": PdpSharedDescriptionAdditionalOptions_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDescriptionAdditionalOptions_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_user",
      "args": null
    }
  ]
};
(node as any).hash = '2f098ff4cb5258338f85c0ac8112da84';
export default node;
